import BaseModelAPI from '../BaseModelAPI';

export default class ArchivedDocument extends BaseModelAPI {
	static entity = 'archiveddocument';
	static entityName = 'archiveddocument';

	static filterMapping = {
		'documentCode' : 'incoming_documents.documentCode',
		'documentNo' : 'incoming_documents.documentNo',
		'createdAt' : 'incoming_documents.createdAt',
		'sifatSurat' : 'incoming_documents.sifatSuratId',
		'sifatSuratId' : 'incoming_documents.sifatSuratId',
		'documentType' : 'incoming_documents.documentTypeId',
		'documentTypeId' : 'incoming_documents.documentTypeId',
		'description' : 'incoming_documents.description',
		'archivedStatus' : 'archivedDocumentStatus.name',
		'archivedStatusId' : 'archivedDocumentStatus.name',
		'documentLocation' : 'incoming_documents.documentLocationId',
		'documentLocationId' : 'incoming_documents.documentLocationId',
		'remarks' : 'incoming_documents.remarks',
	};

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.noBeritaAcara = '';
			this.archivedDateFrom = '';
			this.archivedDateTo = '';
			this.documentLocationId = '';
			this.documentLocation = {};
			this.picId = '';
			this.pIC = {};
			this.approvedById = '';
			this.approvedBy = {};
			this.removalMethodId = '';
			this.removalMethod = {};
			this.remarks = '';
			this.investigatorDetail = []
			this.incomingDocumentId = '';
			this.incomingDocument = {};
			this.outgoingDocumentId = '';
			this.outgoingDocument = {};
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}